import { useEffect, useState } from 'react';

/**
 * Tracks `prefers-reduced-motion: reduce`.
 *
 * Read in JS as well as CSS because the generated SVG artwork has to be built
 * differently — perpetual animation is REMOVED under reduced motion, not shortened, and
 * an SVG-as-image cannot reliably resolve the media query itself.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => matchReducedMotion());

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = () => {
      setReduced(query.matches);
    };

    // No initial setState here: useState is already seeded from the same query, and
    // calling it synchronously in the effect only triggers a cascading render.
    query.addEventListener('change', onChange);

    return () => {
      query.removeEventListener('change', onChange);
    };
  }, []);

  return reduced;
}

function matchReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
